import React from 'react';
import { CircularProgress } from '@material-ui/core';
import { CheckCircle, Error as ErrorIcon, RadioButtonUnchecked, Warning } from '@material-ui/icons';
import { ImportActivityRow } from '../activity-import-types';

export type RowStatusKind = 'ready' | 'issues' | 'creating' | 'created' | 'failed';

export interface RowStatus {
  kind: RowStatusKind;
  label: string;
}

export const getRowStatus = (row: ImportActivityRow, errorCount: number): RowStatus => {
  if (row.createStatus === 'creating') return { kind: 'creating', label: 'Creating' };
  if (row.createStatus === 'created') return { kind: 'created', label: 'Created' };
  if (row.createStatus === 'failed') return { kind: 'failed', label: row.createError ?? 'Failed to create' };
  if (errorCount > 0) {
    return { kind: 'issues', label: `${errorCount} ${errorCount === 1 ? 'issue' : 'issues'} to fix` };
  }
  return { kind: 'ready', label: 'Ready to create' };
};

export const StatusIcon = ({ kind, size = 16 }: { kind: RowStatusKind; size?: number }) => {
  const style = { fontSize: size, display: 'block' };
  switch (kind) {
    case 'creating':
      return <CircularProgress size={size - 4} />;
    case 'created':
      return <CheckCircle style={{ ...style, color: '#4CAF50' }} />;
    case 'failed':
      return <ErrorIcon style={{ ...style, color: '#D32F2F' }} />;
    case 'issues':
      return <Warning style={{ ...style, color: '#F59E0B' }} />;
    default:
      return <RadioButtonUnchecked style={{ ...style, color: '#9E9E9E' }} />;
  }
};
